import { Actions, ActionsColumn, BootstrapDataTable, Column, IdColumn, Relative } from "react-admin-base-bootstrap";
import { FormattedDate } from "react-intl";

export default function ContentDataTable({url}) {
	return <BootstrapDataTable noStrip url={url} add={url + "/create"}>
		<thead>
		<tr>
			<IdColumn />
	
			<Column sort="content.language.name">Language</Column>
			<Column>Featured</Column>
			<Column sort="name">Title</Column>
			<Column>Author</Column>
	
			<Column>Tags</Column>
			<Column>Enabled</Column>
	
			<Column sort="published_at">Published at</Column>
			<Column sort="created_at">Created at</Column>
			<Column sort="updated_at">Updated at</Column>
	
			<ActionsColumn />
		</tr>
		</thead>
		<tbody>
		{
			row => <tr key={row.id}>
				<td className="min text-center">{row.id}</td>
				<td className="text-center">
					{ row.content?.language?.icon && <Relative>
						<img src={row.content.language.icon.access_url} className="me-2" style={{ width: '24px', height: '24px' }} alt={row.content.language.name} />
					</Relative> }
					{(row.content?.language?.language_code || '-').toUpperCase()}
				</td>
				<td>
					{ row.content.featured_image && <Relative>
						<img src={row.content.featured_image.access_url} alt={row.content.name} width='100px' />
					</Relative> }
				</td>
				<td>
					{ row.content.name }
				</td>
				<td>
					{ (row.content.author && row.content.author.name) || '-' }
				</td>
	
				<td>{(row.content.tags || []).join(", ")}</td>
	
				<td>{ row.content.enabled ? 'Yes' : 'No' }</td>
	
				<td><FormattedDate value={row.content.published_at} /></td>
				<td><FormattedDate value={row.created_at} /></td>
				<td><FormattedDate value={row.updated_at} /></td>
	
				<Actions
					edit={url + "/" + row.id + "/edit"}
					del={url + "/" + row.id}
				/>
			</tr>
		}
		</tbody>
	</BootstrapDataTable>;
}